import { useWidget } from '../context/WidgetContext.js';
import { IconChevronDown } from './icons.js';

type ScrollJumpButtonProps = {
  count: number;
  onClick: () => void;
};

export function ScrollJumpButton({ count, onClick }: ScrollJumpButtonProps) {
  const { t } = useWidget();
  const label =
    count > 0 ? t.newMessages(count) : t.scrollToLatest;

  return (
    <button
      type="button"
      className="teo-scroll-jump"
      onClick={onClick}
      aria-label={label}
    >
      <IconChevronDown size={20} />
      {count > 0 && (
        <span className="teo-scroll-jump__badge" aria-hidden>
          {count > 99 ? '99+' : count}
        </span>
      )}
    </button>
  );
}
